// removed by extract-text-webpack-plugin
module.exports = {"fileIcon":"_1eC2PYOp1-F1iuYqSrM_mJ"};


//////////////////
// WEBPACK FOOTER
// ./src/UI/FilenameWithIcon/FilenameWithIcon.css
// module id = 729
// module chunks = 3